<template>
	<v-tabs
		:value="value"
		:active-class="activeClass"
		:background-color="backgroundColor"
		:center-active="centerActive"
		:centered="centered"
		:color="color"
		:dark="dark"
		:fixed-tabs="fixedTabs"
		:grow="grow"
		:height="height"
		:hide-slider="hideSlider"
		:icons-and-text="iconsAndText"
		:light="light"
		:right="right"
		:show-arrows="showArrows"
		:slider-color="sliderColor"
		:slider-size="sliderSize"
		:vertical="vertical"
		v-bind="$attrs"
		v-on="unhandled_events"
		@change="on_change"
	>
		<slot></slot>
	</v-tabs>
</template>

<script>
export default {
	inheritAttrs: false,
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: [String, Number],
		activeClass: String,
		backgroundColor: String,
		centerActive: Boolean,
		centered: Boolean,
		color: String,
		dark: Boolean,
		fixedTabs: Boolean,
		grow: Boolean,
		height: [Number, String],
		hideSlider: Boolean,
		iconsAndText: Boolean,
		light: Boolean,
		right: Boolean,
		showArrows: [Boolean, String],
		sliderColor: String,
		sliderSize: [Number, String],
		vertical: Boolean
	},
	computed: {
		unhandled_events() {
			const { change, ...listeners } = this.$listeners;
			return listeners;
		}
	},
	methods: {
		on_change(value) {
			this.$emit('change', value);
		}
	}
};
</script>
